/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationRequest,
  SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationResponse,
  SetSettingsApiV1NotificationsFeedUserEventSettingsPatchHeaderParams,
  SetSettingsApiV1NotificationsFeedUserEventSettingsPatch422,
} from '../../types/SetSettingsApiV1NotificationsFeedUserEventSettingsPatch.ts'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

export const setSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationKey = () => [{ url: '/api/v1/notifications_feed_user_event/settings' }] as const

export type SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationKey = ReturnType<
  typeof setSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationKey
>

/**
 * @summary Set Settings
 * {@link /api/v1/notifications_feed_user_event/settings}
 */
export async function setSettingsApiV1NotificationsFeedUserEventSettingsPatch(
  data?: SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationRequest,
  headers?: SetSettingsApiV1NotificationsFeedUserEventSettingsPatchHeaderParams,
  config: Partial<RequestConfig<SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const res = await request<
    SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationResponse,
    ResponseErrorConfig<SetSettingsApiV1NotificationsFeedUserEventSettingsPatch422>,
    SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationRequest
  >({
    method: 'PATCH',
    url: `/api/v1/notifications_feed_user_event/settings`,
    data: requestData,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  })
  return res.data
}

/**
 * @summary Set Settings
 * {@link /api/v1/notifications_feed_user_event/settings}
 */
export function useSetSettingsApiV1NotificationsFeedUserEventSettingsPatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationResponse,
      ResponseErrorConfig<SetSettingsApiV1NotificationsFeedUserEventSettingsPatch422>,
      {
        data?: SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationRequest
        headers?: SetSettingsApiV1NotificationsFeedUserEventSettingsPatchHeaderParams
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationRequest>> & { client?: typeof fetch }
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? setSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationKey()

  return useMutation<
    SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationResponse,
    ResponseErrorConfig<SetSettingsApiV1NotificationsFeedUserEventSettingsPatch422>,
    {
      data?: SetSettingsApiV1NotificationsFeedUserEventSettingsPatchMutationRequest
      headers?: SetSettingsApiV1NotificationsFeedUserEventSettingsPatchHeaderParams
    },
    TContext
  >(
    {
      mutationFn: async ({ data, headers }) => {
        return setSettingsApiV1NotificationsFeedUserEventSettingsPatch(data, headers, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}